import type { FeatureRoute } from '../types';
import { DashboardPage } from './DashboardPage';

/** The dashboard (A1) is the index route: path ''. */
export const routes: FeatureRoute[] = [{ path: '', element: <DashboardPage /> }];
